import { render } from "./indexCowork.vue?vue&type=template&id=7a97a958"
import script from "./indexCowork.vue?vue&type=script&lang=js"
export * from "./indexCowork.vue?vue&type=script&lang=js"

import exportComponent from "/home/afreet/public_html/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__